import React, { useEffect, useState } from 'react'


import styles from '../../css/style.module.css'
import { RiDeleteBin6Line } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";
import { FaPlus } from "react-icons/fa6";

import { VscSettings } from "react-icons/vsc";

import HOC from '../../components/HOC/HOC'
import { Link, useNavigate } from 'react-router-dom';
import { DeleteSuccessfullyModal, SuccessfullyModal } from '../../components/Modals/Modals';
import FilterModal from '../../components/Modals/FilterModal';
import { deleteApi, getApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';

import img2 from '../../assest/loading1.gif'
import { formatDateTime } from '../../utils/utils'


const columns = [
    'S.no',
    'Question Title',
    'Answer',
    'Category',
    'Last Updated Date',
    'View Count',
    'Creation Date',
    'Status',
    'Action'
];





const FAQ = () => {
    const navigate = useNavigate()
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const [faqdata, setFaqData] = useState([])
    const [loading, setLoading] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState("");
    const [selecteddata, setSelectedData] = useState(null);


    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    const fetchData = async () => {
        await getApi(endPoints.getallfaq(selectedFilter), {
            setResponse: setFaqData,
            setLoading,
            errorMsg: 'Failed to fetch faq!'
        });
    };

    useEffect(() => {
        fetchData();
    }, [selectedFilter]);



    const handleDelete = async () => {
        if (!selecteddata) return;

        await deleteApi(endPoints.deletefaq(selecteddata), {
            setLoading,
            // successMsg: 'Category deleted successfully!',
            errorMsg: 'Failed to delete FAQ!'
        });

        fetchData();
        setShowDeleteModal(false);
        setShowSuccessModal(true);
        setTimeout(() => setShowSuccessModal(false), 2000);
    };


    const openDeleteModal = (categoryId) => {
        setSelectedData(categoryId);
        setShowDeleteModal(true);
    };


    const filterOptions = [
        { label: "Published", value: "Published" },
        { label: "Un Published", value: "Un Published" },
        { label: "Drafts", value: "Drafts" },
    ];


    const handleApply = (appliedFilter) => {
        setSelectedFilter(appliedFilter);
        setShowDropdown(false);
    };

    return (
        <>
            <DeleteSuccessfullyModal
                show={showDeleteModal}
                handleClose={() => setShowDeleteModal(false)}
                handleConfirm={handleDelete}
                text="delete faq"
            />
            <SuccessfullyModal
                show={showSuccessModal}
                handleClose={() => setShowSuccessModal(false)}
                text="Successfully Deleted"
            />
            <div className={styles.jobmanagementCotainer}>
                <div className={styles.jobtoppart}>
                    <div className={styles.pagetitle}>
                        <h6>FAQ’s</h6>
                    </div>
                    <div className={styles.rightbuttons}>
                        <div className={styles.rightbuttons2} onClick={() => navigate('/FAQ/add')}>
                            <FaPlus color='#FFFFFF' />
                            <p>Add New FAQ</p>
                        </div>
                        <div className={styles.filterbutton} onClick={toggleDropdown}>
                            <VscSettings color='#737373' size={20} />
                            <p>Filters</p>
                        </div>
                        {showDropdown && (
                            <FilterModal
                                handleApply={handleApply}
                                filterOptions={filterOptions}
                                selectedFilter={selectedFilter}
                            />
                        )}
                    </div>
                </div>
                <div className={styles.jobchildcontainer}>
                    <div className={styles.tablecontainer}>
                        <table className={styles.table1}>
                            <thead>
                                <tr>
                                    {columns.map((label, index) => (
                                        <th key={index} className={styles.tableHeader}>{label}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="12" style={{ textAlign: "center", padding: "1rem" }}>
                                            <img src={img2} alt="Loading" width={100} height={100} />
                                        </td>
                                    </tr>
                                ) : (!faqdata?.data || Object.keys(faqdata.data).length === 0) ? (
                                    <tr>
                                        <td colSpan="12" style={{ textAlign: "center", padding: "1rem" }}>
                                            No data available.
                                        </td>
                                    </tr>
                                ) : (
                                    faqdata?.data?.map((item, rowIndex) => (
                                        <tr key={rowIndex} className={styles.tableRow}>
                                            <td className={styles.tableCell}>{rowIndex + 1}</td>
                                            <td className={styles.tableCell}>{item?.question || "N/A"}</td>
                                            <td className={styles.tableCell}>{item?.answer || "N/A"}</td>
                                            <td className={styles.tableCell}>{item?.category?.name || "Uncategorized"}</td>
                                            <td className={styles.tableCell}>{formatDateTime(item?.updatedAt)}</td>
                                            <td className={styles.tableCell}>{item?.viewCount || 0}</td>
                                            <td className={styles.tableCell}>{formatDateTime(item?.createdAt)}</td>
                                            <td className={styles.tableCell}
                                                style={{
                                                    color:
                                                        item?.status === 'Published' ? '#00AD1D' :
                                                            item?.status === 'Un Published' ? '#FFA800' : '#FF0E0E',
                                                    fontWeight: '600'
                                                }}
                                            >
                                                {item?.status || "Unknown"}
                                            </td>
                                            <td>
                                                <div className={styles.tableaction}>
                                                    <Link to={`/FAQ/edit/${item?._id}`}>
                                                        <FaRegEdit size={20}   style={{ cursor: "pointer", color: "#e9b44a" }} />
                                                    </Link>
                                                    <RiDeleteBin6Line
                                                        size={20}
                                                        onClick={() => openDeleteModal(item._id)}
                                                        style={{ cursor: "pointer", color: "#d9534f" }}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>

                        </table>
                    </div>
                </div>

            </div >
        </>
    )
}

export default HOC(FAQ)
